import { useCallback } from 'react';
import {
  useSafeExpoNavigation,
  useSafeFocusEffect,
  useSafeNavigation,
} from '@sg/garnish';

export const useCustomScreenTitle = (
  title: string,
  shouldUsePostfix = true,
) => {
  const expoNavigation = useSafeExpoNavigation();
  const reactNavigation = useSafeNavigation();
  const navigation = expoNavigation ?? reactNavigation;

  useSafeFocusEffect(
    useCallback(() => {
      if (!title) return;

      const formattedTitle = shouldUsePostfix ? `${title} | sweetgreen` : title;

      navigation?.setOptions({ customDocumentTitle: formattedTitle });
    }, [navigation, title, shouldUsePostfix]),
  );
};
